module.exports = __webpack_public_path__ + "img/kha.ee98adf.png";